export default __webpack_public_path__ + "static/media/img7.55e5efbd.png";